import { render, staticRenderFns } from "./PrecosCondicoes.vue?vue&type=template&id=5d3e1b82&scoped=true"
import script from "./PrecosCondicoes.vue?vue&type=script&lang=js"
export * from "./PrecosCondicoes.vue?vue&type=script&lang=js"
import style0 from "./PrecosCondicoes.vue?vue&type=style&index=0&id=5d3e1b82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3e1b82",
  null
  
)

export default component.exports